import { Tabs, Row } from "antd";
// import { LaserClassResultsV2 } from "../../pages/Loginv2/Calculators/Results/MPE_AEL_Results/LaserClassResultsV2";
// import LaserClassVerdict from "../../pages/Loginv2/Calculators/Results/MPE_AEL_Results/LaserClassVerdict";
// import { AELTab } from "./AEL";
import { ANSILaserClassResults } from "./ANSILaserClassResults";
import LaserClassVerdict from "../../../pages/Loginv2/Calculators/Results/MPE_AEL_Results/LaserClassVerdict";
import { ANSIAELTab } from "./ANSIAEL";

export function AllAELANSI(laserClassResults){
    const {props} = laserClassResults
    return(
        <Tabs
            style={{width:"100%"}}
            centered
            items={[
            {
                key: 1,
                label: "Overall",
                children:
                <>
                        <ANSILaserClassResults results={props.result.ansiAEL} condition={1} laserOperation={props.result.laserOperation} />
                        <ANSILaserClassResults results={props.result.ansiAEL} condition={2} laserOperation={props.result.laserOperation}/>
                        <LaserClassVerdict laserClass={props.result.verdict} />

                </>
            },
            {
                key: 2,
                label: "Class 1",
                children: 
                <>
                    <ANSIAELTab class={"1"} results={props.result.ansiAEL} laserOperation={props.result.laserOperation}/>
                </>
            },
            {
                key: 3,
                label: "Class 2",
                children:   
                <>
                    <ANSIAELTab class={"2"} results={props.result.ansiAEL} laserOperation={props.result.laserOperation}/>
                </>
            },
            {
                key: 4,
                label: "Class 3R",
                children:  
                <>
                    <ANSIAELTab class={"3r"} results={props.result.ansiAEL} laserOperation={props.result.laserOperation}/>
                </>
            },
            {
                key: 5,
                label: "Class 3B",
                children:   
                <>
                    <ANSIAELTab class={"3b"} results={props.result.ansiAEL} laserOperation={props.result.laserOperation}/>
                </>
            }

        ]}
        />
    )
}